import React from 'react';

import Button from 'components/partials/button/button';
import Icons from 'assets/icons';
import classNames from 'classnames';

interface LabelProps {
  children: React.ReactNode;
}

const Label = ({ children }: LabelProps): React.JSX.Element => (
  <div className="text-navy-500 text-base font-semibold mb-1">{children}</div>
);

const Value = ({ children }: LabelProps): React.JSX.Element => (
  <div className="text-navy-800 text-xl font-bold capitalize">{children}</div>
);

interface GoalsManagerHeaderProps {
  type: string | undefined;
  category: string | undefined;
  year: string | number;
  handleNewGoalClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isCreation: boolean;
  isEdition: boolean;
  customClass?: string;
}

const GoalsManagerHeader = ({
  type,
  category,
  year,
  handleNewGoalClick,
  isCreation,
  isEdition,
  customClass,
}: GoalsManagerHeaderProps): React.JSX.Element => (
  <div
    className={classNames(
      'flex justify-between items-end flex-wrap',
      customClass
    )}
    data-testid="goal-header"
  >
    <div className="flex gap-6">
      <div>
        <Label>Category</Label>
        <Value>{category}</Value>
      </div>
      <div>
        <Label>Type</Label>
        <Value>{type}</Value>
      </div>
      <div>
        <Label>Entry term</Label>
        <Value>{year}</Value>
      </div>
    </div>

    <Button
      variant="brand-filled"
      onClick={handleNewGoalClick}
      disabled={isCreation || isEdition}
      size="lg"
      iconBefore={<Icons.Plus aria-label="PlusIcon" />}
      data-testid="add-goal-button"
    >
      Add a goal
    </Button>
  </div>
);

export default GoalsManagerHeader;
